import React from "react";
import ReactDOM from "react-dom";
import VUApiHistory from "./VUApiHistory.jsx";
export function initVUApiHistory() {
  document.querySelectorAll(".js-vu-api-history").forEach(mount => {
    ReactDOM.render(<VUApiHistory />, mount);
  });
}
